import Vue from "vue";
import Vuex from "vuex";
import ajax from "@/utils/ajax";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // 缓存组件
    cacheComponents: [],
    // token
    token: "",
    // 用户信息
    user: {},
    searchInfo: {},
  },
  mutations: {
    // 向缓存中添加组件
    ["ADD_COMPONENTS"](state, componentName) {
      if (state.cacheComponents.includes(componentName)) {
        return;
      }
      state.cacheComponents.push(componentName);
    },
    // 从缓存中移除组件
    ["REMOVE_COMPONENTS"](state, componentName) {
      const index = state.cacheComponents.indexOf(componentName);
      if (index === -1) {
        return;
      }
      state.cacheComponents.splice(index, 1);
    },
    // 设置token
    ["SET_TOKEN"](state, token) {
      state.token = token;
    },
    // 设置用户信息
    ["SET_USER"](state, userInfo) {
      state.user = userInfo;
    },
    //保存查询信息
    ["SET_SEARCH_DATA"](state, searchData) {
      state.searchInfo = searchData;
    },
  },
  actions: {
    getUserInfo({ commit }) {
      return ajax.post(`/user/userInfo`).then((res) => {
        const userInfo = JSON.parse(JSON.stringify(res.data));
        // 科普员类型 0-中国科协级、1-省级、2-市级、3-县区级、4-乡镇级、5-个人级
        userInfo.sciencer_type = parseInt(userInfo.sciencer_type);
        switch (userInfo.sciencer_type) {
          case 0:
            userInfo.currentAreaName = "全国";
            userInfo.currentAreaCode = "0";
            userInfo.currentAreaPinyin = "china";
            break;
          case 1:
            userInfo.currentAreaName = userInfo.province_name;
            userInfo.currentAreaCode = userInfo.province_code;
            break;
          case 2:
            userInfo.currentAreaName = userInfo.city_name;
            userInfo.currentAreaCode = userInfo.city_code;
            break;
          case 3:
            userInfo.currentAreaName = userInfo.country_name;
            userInfo.currentAreaCode = userInfo.country_code;
            break;
          case 4:
            userInfo.currentAreaName = userInfo.town_name;
            userInfo.currentAreaCode = userInfo.town_code;
            break;
          case 6:
            userInfo.currentAreaName = userInfo.society_org_name;
            userInfo.currentAreaCode = "0";
            if (Number(userInfo.society_org_id) > 0) {
              // 学会注册过机构
              userInfo.sciencer_type = 6.1;
            }
            break;
          default:
            throw {
              errorMsg: "获取用户信息当前区域错误",
              code: 996, // 统一登录，没有权限的用户.
              userInfo: userInfo, // 统一登录，没有权限的用户.
            };
        }
        commit("SET_USER", userInfo);
      });
    },
    updateSearchData({ commit }, data) {
      commit("SET_SEARCH_DATA", data);
    },
  },
  getters: {
    user: ({ user }) => {
      return user;
    },
  },
  modules: {},
});
